<div #reportContent class="purchase-confirmation">
  <div class="header">
    <img src="/img/Parent@2x.png" class="header-image">
    <div class="contact-info">
      <div style="font-weight:600">Royal New York</div>
      <div>661 Hadley Rd.</div>
      <div>South Plainfield, NJ 07080</div>
      <div>Phone: (908) 756-6400</div>
    </div>
    <h3>Purchase Confirmation</h3>
  </div>
  <hr />
  <fieldset style="width:95%">
    <legend style="font-size:16px; font-weight:bold">Purchase Order # {{PurchaseOrder.PurchaseOrderID}}</legend>
    <div class="purchase-information">
      <div class="supplier-data">
        <div style="font-size:16px; font-weight:bold">Supplier</div>
        <div>{{PurchaseOrder.SupplierName}}</div>
        <div>{{PurchaseOrder.SupplierAgent}}</div>
        <div>Phone: {{PurchaseOrder.SupplierTel}}</div>
        <div>Fax: {{PurchaseOrder.SupplierFax}}</div>
      </div>
      <div class="purchase-order-data">
        <div class="data">
          <div>Purchase Date:</div>
          <div>{{PurchaseOrder.PurchaseDate | date : 'MM-dd-yyyy'}}</div>
        </div>
        <div class="data">
          <div>Intermediary:</div>
          <div>{{PurchaseOrder.Intermediary}}</div>
        </div>
        <div class="data">
          <div>Intermediary Number:</div>
          <div>{{PurchaseOrder.IntermediaryNumber}}</div>
        </div>
        <div class="data">
          <div>Payment Terms:</div>
          <div>{{PurchaseOrder.Inventory[0].PaymentTermName}}</div>
        </div>
        <div class="data">
          <div>Purchase Position:</div>
          <div>{{PurchaseOrder.Inventory[0].FinalPosition}}</div>
        </div>
        <div class="data">
          <div>Destination:</div>
          <div>{{PurchaseOrder.Inventory[0].Destination}}</div>
        </div>
      </div>
    </div>
  </fieldset>
  <div style="min-height:400px;">
    @if(PurchaseOrder){
    <div style="width:100%;"><rms-table [data]="PurchaseOrder.Inventory || []" [columns]="InventoryColumns" [IncludeSearch]="false" [IncludePaginator]="false" [IncludeSort]="false"></rms-table><hr /></div>
    }
    <div style="display:flex; justify-content:space-between; min-height:10%">
      <div>
        <div style="font-weight:bold">Notes:</div>
        <div>{{PurchaseOrder.Notes}}</div>
      </div>
      <div>
        (GP) depicts coffees stored in GrainPro system.<br>
        (E) depicts coffees stored in the Ecotact system.<br>
      </div>
    </div>
  </div>

  <div class="footer">
    <div class="signature-area">
      <div>AGREED: </div>
      <div style="align-items: center; display: flex; flex-direction: column; width: 200px;">
        <div class="signature-line">*</div><br />
        <div style="text-align:center;font-weight:bold; font-size:12px">{{PurchaseOrder.SupplierName}}</div>
        <div style="text-align: center; font-size: 12px">{{PurchaseOrder.SupplierAgent}}</div>
      </div>
      <div style="align-items: center; display: flex; flex-direction: column; width: 200px; ">
        <div class="signature-line">Name</div><br />
        <div style="text-align: center; font-weight: bold; font-size: 12px">ROYAL COFFEE NEW YORK, INC.</div>
        <div style="text-align: center; font-size: 12px">Name</div>
      </div>

    </div>
    <ul style="font-size:10px; gap:0">
      <li>This is an exact copy of our purchase agreement. Please advise us immediately of any discrepancies.</li>
      <li>Please sign and return one (1) copy of this purchase confirmation for our records.</li>
      <li>
        This contract incorporates the provisions, terms, and conditions of the corresponding contract (FOB, Cost Freight,
        Ex Warehouse, etc.) of the Green Coffee Association Inc., including all rulings and bylaws in effect on the date hereof.
      </li>
    </ul>
    <div style="color:red">This Green Coffee is a raw commodity and requires further processing prior to consumption</div>
  </div>
</div>
